import { declareString } from "@1js/localization";

export const AllPromptLabel = declareString("promptLibrary.promptTabAll", {
  text: "All prompts",
  comment: "Label used on the prompt tab component to show all Copilot prompts",
});

export const SavedPromptLabel = declareString("promptLibrary.promptTabSaved", {
  text: "Saved",
  comment:
    "Label used on the prompt tab component to show all saved Copilot prompts (user-authored or Microsoft created)",
});

export const BookmarkedPromptsLabel = declareString(
  "promptLibrary.promptTabBookmarked",
  {
    text: "Bookmarked",
    comment:
      "Label used on the prompt tab component to show all bookmarked Copilot prompts (user-authored or Microsoft created)",
  }
);

export const SuggestedPromptsLabel = declareString(
  "promptLibrary.promptTabSuggested",
  {
    text: "Suggested",
    comment:
      "Label used on the prompt tab component to show suggested Copilot prompts (user-authored or Microsoft created)",
  }
);

export const GroupPromptsLabel = declareString("promptLibrary.promptTabGroup", {
  text: "Team prompts",
  comment:
    "Label used on the prompt tab component to show group Copilot prompts (user-authored or Microsoft created shared with a workgroup in an organization)",
});

export const GroupPromptsLabelRockSteady = declareString(
  "promptLibrary.promptTabGroupRocksteady",
  {
    text: "From your teams",
    comment:
      "Label used on the prompt tab component in RockSteady UX to show group Copilot prompts (user-authored or Microsoft created shared with a workgroup in an organization)",
  }
);

export const WorkplaceLabel = declareString("promptLibrary.workplaceTabGroup", {
  text: "Workplace prompts",
  comment:
    "Label used on the prompt tab component to show workplace Copilot prompts (prompts created by IT admin with an organization). For example, if you are a Costco employee, you will see prompts created by Costco's IT admins designed for Costco employees.",
});

export const WorkplaceLabelRockSteady = declareString(
  "promptLibrary.workplaceTabGroupRocksteady",
  {
    text: "From your organization",
    comment:
      "Label used on the prompt tab component in RockSteady UX to show workplace Copilot prompts (prompts created by IT admin with an organization)",
  }
);

export const MyPromptsLabel = declareString("promptLibrary.promptTabMy", {
  text: "My prompts",
  comment:
    "Label used on the prompt tab component to show user-authored Copilot prompts",
});

export const MicrosoftPromptsLabel = declareString(
  "promptLibrary.promptTabMicrosoft",
  {
    text: "Microsoft prompts",
    comment:
      "Label used on the prompt tab component to show Microsoft-authored Copilot prompts",
  }
);

export const YourPromptsLabel = declareString(
  "promptLibrary.promptTabYourPrompts",
  {
    text: "Your prompts",
    comment:
      "Label used on the prompt tab component to show all the saved prompts",
  }
);
